import { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";

//https://rapidapi.com/weatherapi/api/weatherapi-com/s

function App() {
  const [location, setLocation] = useState("BERKELEY, CALIFORNIA");
  const [locationResult, setLocationResult] = useState();
  const [sunrise, setSunrise] = useState();
  const [sunset, setSunset] = useState();
  const [localDate, setLocalDate] = useState();
  const [temperature, setTemperature] = useState();

  const [weatherIcon, setWeatherIcon] = useState();
  const [weatherConditions, setWeatherConditions] = useState();

  function changeLocation(e) {
    setLocation(e.target.value.toUpperCase());
  }

  useEffect(() => {
    var options = {
      method: "GET",
      url: "https://weatherapi-com.p.rapidapi.com/astronomy.json",
      params: { q: { location } },
      headers: {
        "x-rapidapi-host": "weatherapi-com.p.rapidapi.com",
        "x-rapidapi-key": "c1d4bd538dmsh760aacb9e8e1ef3p161128jsn0aa0b306fa8e"
      }
    };

    axios
      .request(options)
      .then(function (response) {
        //console.log(response.data);
        let data = response.data;
        setSunrise(data.astronomy.astro.sunrise);
        setSunset(data.astronomy.astro.sunset);
        let date = data.location.localtime.slice(0, -5);
        let year = date.slice(0, 4);
        let month = date.slice(5, 7);

        if (month[0] === "0") {
          month = month.slice(-1);
        }
        let day = date.slice(8, 10);

        if (day[0] === "0") {
          day = day.slice(-1);
        }

        let formattedDate = month + "/" + day + "/" + year;
        setLocalDate(formattedDate);

        let locationfromapi = "";

        if (data.location.region === "") {
          locationfromapi = data.location.name + ", " + data.location.country;
        } else {
          locationfromapi =
            data.location.name +
            ", " +
            data.location.region +
            ", " +
            data.location.country;
        }

        setLocationResult(locationfromapi);
      })
      .catch(function (error) {
        console.error(error);
      });
  }, [location]);

  useEffect(() => {
    const weatherOptions = {
      method: "GET",
      url: "https://weatherapi-com.p.rapidapi.com/forecast.json",
      params: { q: { location } },
      headers: {
        "x-rapidapi-host": "weatherapi-com.p.rapidapi.com",
        "x-rapidapi-key": "c1d4bd538dmsh760aacb9e8e1ef3p161128jsn0aa0b306fa8e"
      }
    };

    axios
      .request(weatherOptions)
      .then(function (response) {
        //console.log(response.data);
        let data = response.data;
        setWeatherIcon(data.current.condition.icon);
        setWeatherConditions(data.current.condition.text.toLowerCase());
        setTemperature(data.current.feelslike_f);
        console.log(data.current.condition.text);
      })
      .catch(function (error) {
        console.error(error);
      });
  }, [location]);

  return (
    <>
      <h1>Sunrise / Sunset</h1>

      <div
        style={{
          boxSizing: "border-box",
          padding: "none",
          margin: "0 auto",
          fontSize: "2rem",
          textAlign: "center"
        }}
      >
        <input
          style={{
            boxSizing: "border-box",
            width: "100%",
            margin: "30px auto 10px",
            fontSize: "2rem",
            textAlign: "center"
          }}
          placeholder="Enter city, state"
          onChange={changeLocation}
          value={location}
        />
      </div>

      <p
        style={{
          textAlign: "center",
          marginBottom: "20px",
          fontWeight: "bold"
        }}
      >
        {locationResult}
      </p>

      <p className="theDate">{localDate}</p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 0,
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <img
          src={weatherIcon}
          alt="Current Weather"
          style={{ maxWidth: 40, marginRight: 5, marginLeft: 5 }}
        />
        <p>
          It's currently {weatherConditions} conditions and {temperature}°F
        </p>
      </div>

      <div className="daynightlabel">Day</div>
      <div className="flexcontainer">
        <p>{sunrise}</p>
        <p>-</p>
        <p>{sunset}</p>
      </div>
      <h2>Sunset / Sunrise</h2>
      <div className="daynightlabel">Night</div>
      <div className="flexcontainer">
        <p>{sunset}</p>
        <p>-</p>
        <p>{sunrise}</p>
      </div>
    </>
  );
}

export default App;
